module.exports = __webpack_public_path__ + "img/img_kb_type3_01.22fc0cf2.png";